import { Component, computed, inject, input } from '@angular/core';
import { UsStatesService } from '../../../core/services/us-states.service';

@Component({
    selector: 'app-state',
    imports: [],
    templateUrl: './state.html',
    styleUrl: './state.scss',
})
export class State {
    /** State code passed from parent, e.g. 'ca', 'ny', 'tx' (lowercase) */
    readonly stateCode = input<string>('cap');
    readonly showSelectState = input<boolean>(false);

    private usStatesService = inject(UsStatesService);
    readonly stateDetails = this.usStatesService.currentStateDetails;

    readonly firstOffice = computed(() => {
        const details = this.stateDetails();
        if (details && details.offices && details.offices.length > 0) {
            return details.offices[0];
        }
        return null;
    });

    readonly formattedAddress = computed(() => {
        const office = this.firstOffice();
        if (!office) return '';

        let firstAddressPart = '';
        if (office.address) {
            const values = Object.values(office.address);
            if (values.length > 0) {
                let firstVal = values[0];
                try {
                    if (typeof firstVal === 'string' && firstVal.trim().startsWith('{')) {
                        const parsed = JSON.parse(firstVal);
                        firstVal = Object.values(parsed)[0] as string;
                    }
                } catch (e) {
                    // Ignore parse error
                }
                firstAddressPart = firstVal;
            }
        }

        const addressParts = firstAddressPart ? [firstAddressPart] : [];
        if (office.city) addressParts.push(office.city);
        if (office.zipcode) addressParts.push(office.zipcode);
        return addressParts.filter(p => !!p).join(', ');
    });

    readonly formattedPhone = computed(() => {
        const office = this.firstOffice();
        if (!office) return '';
        return office.phone ? Object.values(office.phone).filter(p => !!p).join(', ') : '';
    });

    /** Full path to the state image asset */
    readonly stateImageUrl = computed(() =>
        `assets/imgs/states/${this.stateCode().toLowerCase() || 'cap'}.png`
    );

}
